/**
 * i18n phase: home quick-info hourly weather modal.
 * Tuples are [ko, en, vi, ru].
 */

const home = {
  weatherHourlyTitle: ['오늘의 날씨', "Today's weather", 'Thời tiết hôm nay', 'Погода сегодня'],
  weatherHourlyTitleWithPlace: [
    '오늘의 날씨 · {place}',
    "Today's weather · {place}",
    'Thời tiết hôm nay · {place}',
    'Погода сегодня · {place}',
  ],
  weatherHourlyLoading: ['불러오는 중…', 'Loading…', 'Đang tải…', 'Загрузка…'],
  weatherHourlyEmpty: [
    '시간별 예보를 불러오지 못했어요',
    "Couldn't load the hourly forecast",
    'Không tải được dự báo theo giờ',
    'Не удалось загрузить почасовой прогноз',
  ],
  weatherHourRow: ['{hour}시 · {emoji} {temp}°', '{hour}:00 · {emoji} {temp}°', '{hour}h · {emoji} {temp}°', '{hour} ч · {emoji} {temp}°'],
  weatherHourlyAria: ['시간별 날씨 보기', 'View hourly weather', 'Xem thời tiết theo giờ', 'Почасовая погода'],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, v]) => {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  });
  return out;
}

function buildLang(langIndex) {
  return {
    home: pick(home, langIndex),
  };
}

export const phaseHomeWeatherHourlyKo = buildLang(0);
export const phaseHomeWeatherHourlyEn = buildLang(1);
export const phaseHomeWeatherHourlyVi = buildLang(2);
export const phaseHomeWeatherHourlyRu = buildLang(3);
